/**
 * Адрес возврата после входа — только внутренний.
 *
 * Значение приходит из строки запроса (`/login?redirect=…`), то есть его может подставить кто
 * угодно ссылкой. Без проверки `//evil.example` или `https://evil.example` увели бы сотрудника
 * с формы входа на чужой сайт — классический open redirect.
 */
export function internalHref(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return undefined;
  }
  return value;
}
